/*eslint no-unused-vars: ["error", { "argsIgnorePattern": "^_" }]*/
import SearchService from '@/services/search.service'

const initialState = { searchResult: {
        last: true,
        totalPages: 0,
        totalElements: 0,
        size: 10,
        numberOfElements: 0,
        first: true,
        empty: true }
      };

export default {
  namespaced: true,
  state: initialState,
  actions: {
    // search({ rootState, commit, dispatch }, { domain, q, paginator }) {
    async init({ _commit }) {
      const res = await SearchService.getInit();
      return res.data;
    },
    async search( context, { domain, q, silence, paginator }) {
      const { rootState, commit, dispatch } = context;
      // console.log(context);
      const res = await SearchService.search(domain, q, silence, paginator);
      commit('setSearchResult', res.data);
      if(!silence) {
        if(rootState.auth.user) {
          await dispatch('my/history', null, {root: true});
        } else {
          await dispatch('my/addHistory', {domain, formula: q}, {root: true});
        }
      }
      return res;
    },
    async getContent({ _commit }, { seq }) {
      const res = await SearchService.getContent(seq);
      return res.data;
    },
    async getUserDocument({ _commit }, { content, paginator }) {
      const res = await SearchService.getUserDocument(content, paginator);
      return res.data;
    },
    async aggregation( _context, { domain, q }) {
      return await SearchService.aggregation(domain, q);
    },
  },
  mutations: {
    setSearchResult(state, searchResult) {
      state.searchResult = searchResult;
    },
  }
};